import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SharedContactInfo {
  email: string | null;
  phone: string | null;
  phone_type: string | null;
  linkedin_url: string | null;
  parish: string | null;
  country: string | null;
  access_level: "owner" | "admin" | "shared" | "none";
}

export function useSharedContactInfo(targetUserId: string | null | undefined) {
  return useQuery({
    queryKey: ["shared_contact_info", targetUserId],
    queryFn: async (): Promise<SharedContactInfo | null> => {
      if (!targetUserId) return null;

      const { data, error } = await supabase.rpc("get_shared_contact_info", {
        target_user_id: targetUserId,
      });

      if (error) throw error;
      
      // Parse the JSON result
      const result = data as unknown as SharedContactInfo;
      return result;
    },
    enabled: !!targetUserId,
  });
}
